import ProductTravelIns from './ProductTravelIns';
export default ProductTravelIns;
